export type Post = {
  tag: string;
  tagTone: "primary" | "accent" | "secondary";
  title: string;
  digest: string;
  meta: string;
  heat: number;
  image: string;
  status: string;
};

export const tickerItems = [
  "深挖帖「头部主播 补贴口径 反转记录」已推进至取证核对阶段",
  "69黑料 · 扒皮现场 新一期全程记录正在生成：品牌公关翻车事件脉络整理中",
  "起底档案库已归档 12 份事件底稿，黑历史挖掘条目同步更新",
  "本周热榜：三组关键证据通过交叉核验，可信度评级上调",
  "持续更新 · 综艺选手人设崩塌事件时间线已还原至 3 个关键节点",
];

export const heatList = [
  { tag: "深挖帖", title: "头部主播 补贴口径 反转记录", heat: 92, phase: "取证核对", no: "01" },
  { tag: "扒皮现场", title: "品牌公关 撤稿声明 前后矛盾", heat: 86, phase: "证据拼图", no: "02" },
  { tag: "起底档案", title: "素人博主 立人设 黑历史挖掘", heat: 81, phase: "内幕还原", no: "03" },
  { tag: "深挖帖", title: "综艺选手 人设崩塌 全程记录", heat: 77, phase: "时间线还原", no: "04" },
  { tag: "黑历史起底", title: "MCN 机构 刷量 操作痕迹", heat: 70, phase: "待跟进", no: "05" },
  { tag: "扒皮现场", title: "知识付费 割韭菜 话术拆解", heat: 64, phase: "进行中", no: "06" },
];

export const featuredPost: Post = {
  tag: "深挖帖 · 全程记录",
  tagTone: "primary",
  title: "一纸补贴声明，三处口径反转：头部主播黑料深扒全程",
  digest:
    "从网友首条风闻，到关键截图交叉比对，再到口径前后矛盾的逐帧拆解。我们顺着公开线索还原整条决策链，把这段深扒现场从起因、发酵到反转的每一帧都摊在台面上。",
  meta: "扒皮现场 · 深挖帖 · 全程记录",
  heat: 92,
  status: "取证核对",
  image:
    "https://readdy.ai/api/search-image?query=dim%20investigative%20editorial%20still%20of%20an%20investigation%20desk%20at%20night%20with%20a%20single%20warm%20desk%20lamp%20beam%20over%20scattered%20printed%20documents%2C%20torn%20newspaper%20clippings%20and%20a%20red%20highlight%20marker%2C%20amber%20lamp%20glow%20against%20off%20white%20paper%20textures%2C%20cinematic%20noir%20mood%2C%20subtle%20crimson%20accent%2C%20high%20detail%2C%20editorial%20composition&width=1200&height=750&seq=feat-2026-01&orientation=landscape",
};

export const digPosts: Post[] = [
  {
    tag: "证据拼图",
    tagTone: "accent",
    title: "两份截图时间轴对不上：关键证据的可信度核验",
    digest:
      "黑料要能立住，先过证据关。同一组聊天记录在不同平台的时间戳差异，究竟算漏洞还是剪辑？我们按像素与元数据逐条拆。",
    meta: "扒皮现场 · 深挖帖",
    heat: 88,
    status: "已还原",
    image:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20two%20contrasting%20phone%20chat%20screenshots%20pinned%20to%20an%20investigation%20board%20with%20red%20circles%20and%20amber%20pins%2C%20warm%20off%20white%20light%2C%20editorial%20documentary%20photography%2C%20clean%20composition%2C%20crimson%20and%20amber%20accents&width=700&height=480&seq=post-2026-01&orientation=landscape",
  },
  {
    tag: "起底档案",
    tagTone: "secondary",
    title: "素人博主立人设：留学经历背后的时间缝隙",
    digest:
      "黑历史挖掘讲究顺藤摸瓜。当一条履历出现三版口径，起底就不再是情绪表达，而是一套可复盘的检索路径。",
    meta: "黑历史挖掘 · 起底档案",
    heat: 81,
    status: "进行中",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20still%20of%20a%20profile%20resume%20dossier%20on%20a%20desk%20with%20a%20magnifying%20glass%20over%20old%20photos%20and%20timeline%20notes%2C%20warm%20neutral%20light%2C%20investigative%20documentary%20aesthetic%2C%20paper%20textures%2C%20amber%20and%20off%20white%20tones&width=700&height=480&seq=post-2026-02&orientation=landscape",
  },
  {
    tag: "内幕还原",
    tagTone: "primary",
    title: "撤稿声明删掉了哪句话？品牌公关的措辞考古",
    digest:
      "扒皮现场不只看爆点。对比前后两版通稿的措辞差异，往往比声明本身更能说明问题。这一步，我们把删掉的字找回来。",
    meta: "扒皮现场 · 深挖帖",
    heat: 76,
    status: "待跟进",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20still%20of%20two%20versions%20of%20a%20press%20release%20with%20text%20strike%20through%20lines%20and%20red%20tracked%20changes%20overlaid%2C%20warm%20desk%20lighting%2C%20documentary%20mood%2C%20paper%20and%20ink%20textures%2C%20crimson%20accent%20details&width=700&height=480&seq=post-2026-03&orientation=landscape",
  },
  {
    tag: "时间线还原",
    tagTone: "accent",
    title: "从爆料到实锤要几步？一条 48 小时的还原链",
    digest:
      "我们用 69 时间轴把 48 小时内的动作摊开：谁先发声、证据何时流出、口径何时收紧。脉络清楚，深扒才不糊涂。",
    meta: "深挖帖 · 全程记录",
    heat: 70,
    status: "已还原",
    image:
      "https://readdy.ai/api/search-image?query=horizontal%20timeline%20visualization%20with%20linked%20photo%20clues%20and%20event%20notes%20on%20an%20off%20white%20board%2C%20amber%20marker%20dots%20and%20red%20threads%2C%20editorial%20documentary%20lighting%2C%20clean%20and%20organized%2C%20warm%20neutral%20tones&width=700&height=480&seq=post-2026-04&orientation=landscape",
  },
];

export const zones = [
  { icon: "ri-focus-3-line", name: "起底档案", desc: "把分散的黑历史线索归档成可检索的底稿库，顺藤摸瓜不重复。" },
  { icon: "ri-history-line", name: "黑历史挖掘", desc: "从公开履历与旧帖里找出口径变化的缝隙，逐条对表。" },
  { icon: "ri-scissors-cut-line", name: "扒皮现场", desc: "深挖帖的核心现场，把反转、撤稿与声明差异摊开逐帧复盘。" },
  { icon: "ri-folder-check-line", name: "证据拼图", desc: "截图、录屏与元数据交叉核验，用可信度分级给黑料定级。" },
  { icon: "ri-time-line", name: "时间线还原", desc: "用一条还原链标记每一帧动作，让深扒过程可复盘可追溯。" },
  { icon: "ri-eye-line", name: "追踪复盘", desc: "对已还原事件做二次回看，补充遗漏节点并修正判断。" },
];

export const timelineSteps = [
  {
    time: "第 1 帧",
    title: "风闻爆料",
    text: "一条匿名深挖帖在评论区出现，指向「补贴口径」存在第三版本，热度开始在小圈层扩散。",
    tag: "深挖帖",
  },
  {
    time: "第 2 帧",
    title: "取证核对",
    text: "深挖小组对公开截图做时间戳与来源交叉核验，把可用的黑料底稿归入证据拼图区。",
    tag: "证据拼图",
  },
  {
    time: "第 3 帧",
    title: "口径拆解",
    text: "前后两版声明逐字对比，发现关键表述被静默替换，扒皮现场锁定三处矛盾点。",
    tag: "扒皮现场",
  },
  {
    time: "第 4 帧",
    title: "内幕还原",
    text: "结合公开动作与时间缝隙，还原整条决策链，形成可复盘的深扒全程记录。",
    tag: "起底档案",
  },
  {
    time: "持续更新",
    title: "追踪复盘",
    text: "事件进入观察期，一旦出现新证据或口径变化，还原链自动续写并修正结论。",
    tag: "全程记录",
  },
];

export const evidenceItems = [
  { icon: "ri-file-text-line", name: "截图留档", rating: "高可信", rate: 92, desc: "同一事件的多源截图完成元数据比对，未被二次剪辑。" },
  { icon: "ri-video-line", name: "录屏片段", rating: "待复核", rate: 68, desc: "画面连贯，但原始录制环境尚未完全溯源，继续追档。" },
  { icon: "ri-time-line", name: "时间轴比对", rating: "已还原", rate: 87, desc: "发稿与撤稿时间缝隙与声明口径逐帧对齐，节点清晰。" },
  { icon: "ri-focus-2-line", name: "措辞考古", rating: "高可信", rate: 95, desc: "前后通稿差异标注完成，删改痕迹作为核心佐证入库。" },
];

export const navLinks = [
  { label: "现场热度榜", href: "#heat" },
  { label: "深挖帖 · 全程记录", href: "#dig" },
  { label: "分区起底档案", href: "#zones" },
  { label: "事件时间线还原", href: "#timeline" },
  { label: "关键证据拼图", href: "#evidence" },
];

export const dossierTracks = [
  { label: "当前深挖对象", value: "头部主播 · 补贴口径", tone: "text-foreground-950" },
  { label: "扒皮现场阶段", value: "取证核对", tone: "text-primary-700" },
  { label: "现场热度", value: "92 / 极高", tone: "text-accent-600" },
  { label: "证据条目", value: "14 组已归档", tone: "text-foreground-950" },
];